import { toast } from "react-toastify";

import { errMsg } from "../../utils/helperFunction";

import { getUserOrdersApi } from "../../api/orderApi";

export const getUserOrders = () => async (dispatch) => {
  try {
    dispatch({
      type: "USER_ORDER_REQ",
    });
    const data = await getUserOrdersApi();

    dispatch({
      type: "USER_ORDER_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "USER_ORDER_ERROR",
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};
